import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { ChildrenProps } from '../../common/interfaces/childrenProps';

const DummyIFrame: React.FC<ChildrenProps> = (props: ChildrenProps) => {
  const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);
  const mountNode = contentRef?.contentWindow?.document?.body;
  window.parent.postMessage(
    JSON.stringify({
      message: 'EXPERIENCE_END',
    }),
    window.location.origin,
  );
  return (
    <iframe title={'Mocked Assessments'} ref={setContentRef}>
      {mountNode && createPortal(props.children, mountNode)}
    </iframe>
  );
};

export default DummyIFrame;
